import { render } from "./ReportsDashboardsSection.vue?vue&type=template&id=9fa684a0&scoped=true"
import script from "./ReportsDashboardsSection.vue?vue&type=script&lang=js"
export * from "./ReportsDashboardsSection.vue?vue&type=script&lang=js"

import "./ReportsDashboardsSection.vue?vue&type=style&index=0&id=9fa684a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa684a0"]])

export default __exports__